import { useState, useCallback } from 'react';
import api from '../services/api';

export const useApi = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const request = useCallback(async (method, endpoint, data = null) => {
    setLoading(true);
    setError(null);
    try {
      let response;
      if (method === 'get') {
        response = await api.get(endpoint);
      } else if (method === 'post') {
        response = await api.post(endpoint, data);
      } else if (method === 'put') {
        response = await api.put(endpoint, data);
      } else {
        response = await api.delete(endpoint);
      }
      return response.data;
    } catch (err) {
      const errorMsg = err.response?.data?.message || err.message || 'An error occurred';
      setError(errorMsg);
      throw err;
    } finally {
      setLoading(false);
    }
  }, []);

  return { request, loading, error };
};

